module.exports = __webpack_public_path__ + "8e9cef55b807fa0e7130942ea908dd27.pdf";